"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.home = exports.Home = exports.StorageParams = exports.StorageKeys = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const app_1 = require("app");
const app_2 = require("app");
const ModalDialog_1 = require("../../Components/ModalDialog");
const RedirectDialog_1 = require("../../Components/RedirectDialog");
const dictionary_1 = require("./dictionary");
const types_1 = require("../../Components/ModalDialog/types");
exports.StorageKeys = {
    shouldRedirect: 'shouldredirect',
    redirectTo: 'redirectto',
};
exports.StorageParams = {
    YES: 'YES',
    UNSELECTED: 'UNSELECTED',
};
class Home extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = '.home-page';
        this.globalSitePath = ['/en/', '/en'];
        this.currentPathname = window.location.pathname;
        this.renderModalDialog = (dictionary, linkToRedirect) => {
            const classes = 'redirect-dialog group';
            const modalId = 'redirectDialog';
            let modal = document.getElementById(modalId);
            if (!modal) {
                modal = document.createElement('div');
                modal.id = modalId;
                document.body.appendChild(modal);
            }
            const onModalClose = () => document.body.removeChild(modal);
            const component = ((0, jsx_runtime_1.jsx)(RedirectDialog_1.RedirectDialog, { message: dictionary.redirectMessage, acceptButtonLabel: dictionary.goToUSLabel, declineButtonLabel: dictionary.stayOnGlobalLabel, linkToRedirect: linkToRedirect, setStorage: this.setRedirectDataToStorage }));
            const additionalModalParameters = {
                classes,
                backdrop: 'static',
                keyboard: true,
                onModalClose
            };
            if (modal) {
                (0, ModalDialog_1.RenderModal)(component, modal, dictionary.redirectMessage, additionalModalParameters, types_1.PopupType.REDIRECT);
            }
        };
        this.processRedirect = (dictionary, redirectUrlEndpoint) => {
            if (this.globalSitePath.indexOf(this.currentPathname) > -1) {
                const { shouldRedirect, redirectTo } = this.getRedirectDataFromStorage();
                switch (true) {
                    case !!redirectTo &&
                        redirectTo !== this.currentPathname &&
                        shouldRedirect === exports.StorageParams.YES &&
                        this.isPathValid(redirectTo):
                        // Redirect if selected
                        document.documentElement.style.opacity = '0';
                        window.location.pathname = redirectTo;
                        break;
                    case shouldRedirect === exports.StorageParams.UNSELECTED && !!redirectTo:
                        // Render modal if not selected
                        this.renderModalDialog(dictionary, redirectTo);
                        break;
                    case !!redirectUrlEndpoint && !shouldRedirect:
                        // Check should redirect
                        (0, app_1.api)(redirectUrlEndpoint, {})
                            .then(({ data: redirectUrl }) => {
                            // Don't render modal if response empty
                            if (redirectUrl) {
                                this.isNeedRedirect(redirectUrl, dictionary);
                            }
                        })
                            .catch(error => console.error('error', error));
                        break;
                    default:
                        // Clear storage if redirect not valid
                        if (shouldRedirect === exports.StorageParams.YES &&
                            !!redirectTo &&
                            !this.isPathValid(redirectTo)) {
                            this.clearStorage();
                        }
                }
            }
        };
        this.getRedirectDataFromStorage = () => {
            const redirectTo = app_2.SessionService.getDataFromStorage(exports.StorageKeys.redirectTo);
            const shouldRedirect = app_2.SessionService.getDataFromStorage(exports.StorageKeys.shouldRedirect);
            return { shouldRedirect, redirectTo };
        };
        this.setRedirectDataToStorage = (url, redirectAction) => {
            app_2.SessionService.setDataToStorage(exports.StorageKeys.shouldRedirect, redirectAction);
            app_2.SessionService.setDataToStorage(exports.StorageKeys.redirectTo, url);
        };
        this.clearStorage = () => {
            app_2.SessionService.removeDataFromStorage(exports.StorageKeys.shouldRedirect);
            app_2.SessionService.removeDataFromStorage(exports.StorageKeys.redirectTo);
        };
        this.isPathValid = (redirectTo) => {
            return app_1.UrlService.isValidUrl(`${window.location.origin}${redirectTo}`);
        };
    }
    OnInit() {
        const dictionary = (0, app_1.transformDictionary)(dictionary_1.redirectDictionary, app_1.AttrService.data(this.el[0], 'dictionary'));
        const redirectUrl = app_1.AttrService.data(this.el[0], 'redirect-url-endpoint');
        this.processRedirect(dictionary, redirectUrl);
    }
    isNeedRedirect(redirectUrl, dictionary) {
        this.setRedirectDataToStorage(redirectUrl, 'UNSELECTED');
        this.renderModalDialog(dictionary, redirectUrl);
    }
}
exports.Home = Home;
exports.home = new Home();
